import './styles.scss';

export const BodyComponent = (props) => {
    return (
        <div className="body-style bg-violet-1000">
            {props.children}
        </div>
    )
}